import React, { useEffect, useState } from 'react'
import LoginForm from '../forms/LoginForm'
import ForgottenPasswordForm from '../forms/ForgottenPasswordForm'
import useChangeURLWithoutRedirect from '../../../common/hooks/useChangeURLWithoutRedirect'
import SetPasswordForm from '../forms/SetPasswordForm'

interface ModalContentProps {
  initialState?: 'login' | 'forgotPassword' | 'setPassword'
  closeModal?: () => void
  onStateChange?: (newState: string) => void
}

const ModalContent: React.FC<ModalContentProps> = ({
  initialState = 'login',
  closeModal,
  onStateChange,
}) => {
  const changeURLWithoutRedirect = useChangeURLWithoutRedirect()

  // Internal content state
  const [contentState, setContentState] = useState(initialState)

  useEffect(() => {
    setContentState(initialState)
  }, [initialState])

  const switchState = (state: string, url?: string) => {
    setContentState(state as any)
    if (onStateChange) {
      onStateChange(state)
    }
    if (url) {
      changeURLWithoutRedirect(url)
    }
  }

  const renderContent = () => {
    switch (contentState) {
      case 'login':
        return (
          <LoginForm
            onLoginSuccess={() => closeModal && closeModal()}
            onSwitchToForgotPassword={() => switchState('forgotPassword', '/forgot-password')}
          />
        )
      case 'forgotPassword':
        return <ForgottenPasswordForm onSwitchToLogin={() => switchState('login', '/login')} />
      case 'setPassword':
        return <SetPasswordForm />
      default:
        return null
    }
  }

  return <>{renderContent()}</>
}

export default ModalContent
